<template>
  <div>
    </div>
</template>

<script></script>
<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins

    .paragraph-card

        +media("<=xsmall")
            margin-top: $baseline

        &--tab_grid
            img
                margin: -1.75rem -1.75rem 0

        &--seo.card
            margin-top: 1rem
            &::before
                content: none

        &--information
            text-align: center
            img
                vertical-align: top
    .card__body
        p
            color: black

</style>
